module.exports = __webpack_public_path__ + "img/logo.5ff7e6c2.png";